export default __webpack_public_path__ + "static/media/frz-logo-morelines.36c3cc50.png";